var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-sidebar"},[_c('hot-table-edit-feature'),_c('edit-feature'),_c('tools'),_c('feature-details-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }